<template>
  <div class="auth-wrapper auth-v2 bg">
    <b-row class="auth-inner m-0">
      <!-- Left Text-->
      <b-col lg="8" />
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <!-- Entwicklungs-Badge -->
          <b-badge
            v-if="processEnv === 'development'"
            variant="warning"
            class="mb-1"
            style="font-size: 1rem;"
          >
            <div class="d-flex align-items-center">
              <feather-icon
                icon="AlertTriangleIcon"
                class="mr-1"
              />
              <span>Entwicklungsumgebung</span>
            </div>
          
            <div v-if="processEnv === 'development'">
              <b-link
                class="text-white"
                :href="baseURL"
                target="_blank"
              >
                {{ baseURL }}
              </b-link>
            </div></b-badge>
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Willkommen bei - Der Lagermeister - 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Bitte einloggen um fortzufahren.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="E-Mail"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="E-Mail"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="bruce@wayne.de"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Passwort</label>
                  <b-link :to="{ name: 'auth-forgot-password-v2' }">
                    <small>Passwort vergessen?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Passwort"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                @click="validationForm"
              >
                Anmelden
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>Keinen Zugang? </span>
            <b-link :to="{ name: 'page-auth-register-v2' }">
              <span>&nbsp;Hier beantragen!</span>
            </b-link>
          </b-card-text> -->
        </b-col>
      </b-col>
      <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BBadge,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import API from '@/service/api'

export default {
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    BBadge,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login/container_lagermeister.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      baseURL: API().defaults.baseURL,
      processEnv: process.env.NODE_ENV,
      envDatabaseHost: process.env.VUE_APP_DATABASE_HOST,
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.authentication.status.loggedIn
    },
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login/container_lagermeister.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/')
    }
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.$store
            .dispatch('getLogin', {
              identifier: this.userEmail,
              password: this.password,
            })
            .then(
              () => {
                this.$router.push('/')

                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Login erfolgreich',
                    icon: 'EditIcon',
                    variant: 'success',
                  },
                })

                this.$store.dispatch('getCustomerEntries')
                this.$store.dispatch('getInquiriesEntries')
                this.$store.dispatch('getPermissionRoles')
                this.$store.dispatch('getMe')
              },
              () => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Login Fehler',
                    icon: 'EditIcon',
                    variant: 'danger',
                  },
                })
              }
            )
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.bg {
  /* The image used */
  background: url('https://der-lagermeister.de/images/2020/01/14/Container_Mu%CC%88nster_large.jpg');

  /* Full height */
  height: 100%;

  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
